module.exports = __webpack_public_path__ + "img/bg-cant-find_medium@2x.7aeca642.jpg";